import { useCallback } from 'react';
import { withWindow } from '@shared/utils/withWindow';

type AllowedWindowFunctionName = 'open'; // later: | 'print' | 'scrollTo'

type AllowedWindowFnArgs<K extends AllowedWindowFunctionName> = Parameters<Window[K]>;
type AllowedWindowFnReturn<K extends AllowedWindowFunctionName> = ReturnType<Window[K]>;

export const useWindowFunction = <K extends AllowedWindowFunctionName>(fnName: K): ((...args: AllowedWindowFnArgs<K>) => AllowedWindowFnReturn<K> | undefined) => {
  return useCallback(
    (...args: AllowedWindowFnArgs<K>) => {
      let result: AllowedWindowFnReturn<K> | undefined;

      withWindow(win => {
        const fn = win[fnName] as (...a: AllowedWindowFnArgs<K>) => AllowedWindowFnReturn<K>;
        result = fn(...args);
      });

      return result;
    },
    [fnName],
  );
};
